<template>
  <b-form-select
    box
    aria-label="Playback speed selector"
    :id="`playback-speed-select-${id}`"
    class="full-width full-height"
    :class="{ 'hide-playback': hidden }"
    v-model="playbackSpeed">
    <option
      v-for="(speed, idx) in speeds"
      class="playboack-option"
      :key="idx"
      :id="`playback-${speed.css}`"
      :disabled="playbackSpeed === speed"
      :value="`${speed.value}`"
      @change="toggleSettingsMenu(false)"
    >
      {{speed.text}}
    </option>
  </b-form-select>
</template>

<script>
/* global _ */
/* global moment */
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
  name: 'playback-speed',
  components: {  },
  props: [
    'hidden',
    'id',
    'speeds'
  ],
  computed: {
    ...mapGetters('player', [
      'bulb',
      'mobile'
    ]),
    playbackSpeed: {
      get() {
        return String(this.bulb.config.speed)
      },
      set(val) {
        this.bulb.config.speed = parseFloat(val)
      },
    },
  },
};
</script>

<style>
  .custom-select.hide-playback {
    display: none;
  }
</style>
